//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from '@/shared/assets/scss/colorsExport.scss';
import ButtonRouter from '@/shared/components/ButtonRouter.vue';
import FCImage from '~/components/FCImage.vue';
import IconBase from '~/components/icons/IconBase.vue';

export default {
  name: 'Kickboxing_Details2',
  components: {
    FCImage,
    ButtonRouter,
    IconBase,
  },
  data: () => ({
    benefits: [
      {
        heading: 'Built For Every Level',
        description:
          "Learn from a variety of real-world fighters to give you authentic kickboxing training you won't find anywhere else.",
        iconData: {
          name: 'EveryLevel',
          width: '24',
          height: '24',
          color: colors.blue,
        },
      },
      {
        heading: 'Rockstar Trainers To Guide You',
        description:
          "Whether you're new to kickboxing or have previous experience, FightCamp kickboxing workouts will provide you with a physical & mental challenge.",
        iconData: {
          name: 'Trainers',
          width: '24',
          height: '24',
          color: colors.blue,
        },
      },
      {
        heading: 'Motivation, Competition, Real Results',
        description:
          'FightCamp is uniquely designed to give you everything you need to bring out your best. Use FightCamp Punch Trackers with the FightCamp app to see in-workout stats & measure progress over time.',
        iconData: {
          name: 'Motivation',
          width: '24',
          height: '24',
          color: colors.blue,
        },
      },
    ],
  }),
};
